import React from 'react';
import classNames from 'classnames';
import { Modal, Button, Col, Row } from 'antd';
import styles from '../Confirmation.module.less';
import modalStyles from './Confirmation.module.less';
import { BankDetails } from '@send-components/Icons';
import { Link as ChakraLink } from '@chakra-ui/react';
import { appConfig } from '@send-base/app.config';
import { Icon } from 'antd';

import { useFeature } from '@sendpayments/react-shared/hooks/useFeature';
import { PD_4823_REBRANDING_2025 } from '@sendpayments/shared-constants/features';
const ButtonWrapper = ({ okButtonText, onOkClick }) => {
  const [
    {
      data: { isEnabled: isRebrandActive },
    },
  ] = useFeature({
    feature: PD_4823_REBRANDING_2025,
    activeValue: undefined,
    functionName: `Captcha`,
    defaultValue: undefined,
  });

  return (
    <div className={styles.buttonWrapper} style={{ marginBottom: 14 }}>
      <Button
        className={classNames(styles.button, isRebrandActive && 'rebrand-primary-button')}
        key="primary"
        type="primary"
        onClick={onOkClick}
      >
        <div style={{ fontSize: 16 }}> {okButtonText} </div>
      </Button>
    </div>
  );
};

export const Confirmation = ({ okButtonText, onCancelClick, onOkClick }) => (
  <Modal
    title={
      <div style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
        <button className={modalStyles.closeBtn} onClick={onCancelClick}>
          <Icon type="close" theme="outlined" size="small" />
        </button>
      </div>
    }
    wrapClassName={classNames(modalStyles.container)}
    visible
    onOk={onOkClick}
    closable={false}
    onCancel={onCancelClick}
    maskClosable={false}
    destroyOnClose={true}
    closeIcon={<Icon type="close" theme="outlined" size="small" />}
    centered
    footer={[
      <p key="moreInfo" style={{ fontSize: 16 }}>
        For more information, click{' '}
        <ChakraLink
          as="a"
          target="_blank"
          fontSize="16px"
          fontWeight={700}
          pr={1}
          href={appConfig.sendPaymentMethods}
          color="primary.base"
        >
          here
        </ChakraLink>
        .
      </p>,
    ]}
    width={480}
  >
    <Col>
      <Row align="middle" justify="center" type="flex">
        <BankDetails with="104px" height="104px" />
      </Row>
      <h1>Updated Bank Details</h1>
      <div>
        <p style={{ fontSize: 16 }}>We’ve updated our AUD pay-in account details.</p>
        <p style={{ fontSize: 16 }}>
          Please update your records and ensure that all payments for this transaction are sent to the correct account.
        </p>
        <p style={{ fontSize: 16 }}>Please acknowledge these changes before proceeding with your payment.</p>
        <ButtonWrapper key="buttonWrapper" okButtonText={okButtonText} onOkClick={onOkClick} />
      </div>
    </Col>
  </Modal>
);
